<div style="text-align:center;padding-top:10px" *ngIf="doctors.length == 0 && isBusy==false" translate>No Practitioners data exists for student</div>
<div *ngIf="doctors.length > 0 ">
  <mat-table matSort matSortDisableClear matSortActive="Name" [dataSource]="angularMatData" aria-label="Doctors Data Table">
    <ng-container matColumnDef="DoctorName">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Name</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="DoctorName" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let doc">{{doc.DoctorName}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Address">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Address</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="Address" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let doc">{{doc.Address}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Telephone">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Telephone</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="Telephone" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let doc">{{doc.Telephone}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Email">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Email</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="Email" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let doc">{{doc.Email}}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayDoctorsColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayDoctorsColumns;" [attr.aria-label]="getDoctorsAriaRow(row)"></mat-row>
  </mat-table>
</div>
